var createContext = require('react').createContext;
var MatomoContext = createContext(null);
module.exports = MatomoContext;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-react/es/MatomoContext.js
// module id = 216
// module chunks = 0